module.exports = __webpack_public_path__ + "images/fa-tyf-exams.webp";